//@ts-nocheck

import {FC, useState} from 'react'
import printJS from 'print-js'
import {labelImageTypes} from 'app/features/orders/redux/labelTypes'
import SelectPrinters from './SelectPrinters'
import toLower from 'lodash/toLower'

type Props = {
  shippingLabel: any
}

const PrintShippingLabel: FC<Props> = ({shippingLabel}) => {
  const [showPrinterDialog, setShowPrinterDialog] = useState(false)
  const handlePrintLabel = () => {
    if (
      shippingLabel.docType &&
      (shippingLabel.docType.startsWith(labelImageTypes.zpl) ||
        shippingLabel.docType.startsWith(labelImageTypes.epl))
    ) {
      setShowPrinterDialog(true)
    } else if (shippingLabel.graphicImage) {
      printJS({
        printable: `data:image/png;base64,${shippingLabel.graphicImage}`,
        type: 'image',
      })
    } else if (
      shippingLabel.encodedLabel &&
      toLower(shippingLabel.docType) === toLower(labelImageTypes.pdf)
    ) {
      printJS({
        printable: shippingLabel.encodedLabel,
        type: 'pdf',
        base64: true,
      })
    } else if (
      shippingLabel.encodedLabel &&
      toLower(shippingLabel.docType) === toLower(labelImageTypes.png)
    ) {
      printJS({
        printable: `data:image/png;base64,${shippingLabel.encodedLabel}`,
        type: 'image',
      })
    } else {
      printJS(shippingLabel.url)
    }
  }

  const handleClose = () => {
    setShowPrinterDialog(false)
  }

  return (
    <>
      <div onClick={handlePrintLabel}>
        <span className='text-hover-primary'>Print shipping label</span>
      </div>

      {showPrinterDialog && (
        <SelectPrinters
          shippingLabel={shippingLabel}
          show={showPrinterDialog}
          onClose={handleClose}
        />
      )}
    </>
  )
}

export default PrintShippingLabel
